module.exports = __webpack_public_path__ + "static/media/dish.6db37d1d.svg";